// DO NOT EDIT MANUALLY!
// This file is generated, edit `resources/Localizations.json` and run `npm run generate-translation-keys` to update.
import type { TranslationKey } from '~/models';

export const defaultTranslations: Record<TranslationKey, string> = {
  FindingProduct: 'Finding the best product for you',
  GetNewRecommendation: 'Get new recommendation',
  Recommendation: 'We have a product recommendation for you',
  SeeRecommendedProduct: 'See recommended product',
};
